import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type RoutesAction = ActionType<typeof actions>;

export interface RouteItem {
  direction: string;
  totalSearches: number;
  totalClicks: number;
  totalUniqueClicks: number;
  totalPaidBookings: number;
  totalTurnover: number;
  totalProfit: number;
  totalErrors: number;
  totalZeros: number;
  totalTimeouts: number;
  ctr: number;
  str: number;
  avgCheck: number;
}

export enum RoutesActionTypes {
  TABLE_FETCH_REQUEST = "@Routes/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Routes/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Routes/TABLE_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Routes/GENERATE_REPORT_REQUEST",
}

export interface RoutesState {
  readonly count: number;
  readonly isLoading: boolean;
  readonly items: RouteItem[];
}
